import { SmileOutlined } from '@ant-design/icons';
import { Button, Result } from 'antd';
import React from 'react';
import { useNavigate } from 'react-router-dom';

function OrdersContainer() {
  const navigate = useNavigate();

  return (
    <Result
      icon={<SmileOutlined />}
      title="Stay Tuned! This page is coming soon..."
      extra={
        <Button
          type="primary"
          onClick={() => {
            navigate('/');
          }}
        >
          Go Home
        </Button>
      }
    />
  );
}

export default OrdersContainer;
